interface Props {
  onApprove: () => void;
  onReject: () => void;
  disabled?: boolean;
}

export default function DecisionButtons({
  onApprove,
  onReject,
  disabled,
}: Props) {
  return (
    <div className="flex gap-4 justify-center mt-8">
      <button
        onClick={onReject}
        disabled={disabled}
        className="px-8 py-3 bg-red-600 hover:bg-red-700 disabled:bg-red-800 disabled:cursor-not-allowed text-white font-semibold rounded-lg transition-colors"
      >
        Request Changes
      </button>
      <button
        onClick={onApprove}
        disabled={disabled}
        className="px-8 py-3 bg-green-600 hover:bg-green-700 disabled:bg-green-800 disabled:cursor-not-allowed text-white font-semibold rounded-lg transition-colors"
      >
        Approve
      </button>
    </div>
  );
}
